import { Column, RowNode, ValueGetterParams } from "ag-grid-community";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { safeParseFloat } from "lib/number";
import { MergedColumnFormulaOptions } from "./types";

// To get best performance, use this function instead of Math.max
// Copied from https://stackoverflow.com/a/30334278, modified to parse number-like string
function findMax(array) {
    let max = 0,
        counter;

    for (counter = 0; counter < array.length; counter++) {
        const parsedValue = safeParseFloat(array[counter], 0);
        if (parsedValue > max) {
            max = parsedValue;
        }
    }
    return max;
}

/**
 * Function to recursively traverse through node groups to get unique door
 */
const countUniqueDoor = (seenSet: Set<string>, node: RowNode, column: Column) => {
    if (node.group) {
        node.childrenAfterGroup.forEach((childNode) => {
            // Node without data is a parent with nested row groups. Thus, traverse down.
            if (!childNode.data) {
                countUniqueDoor(seenSet, childNode, column);
            } else {
                (childNode.data._doorsWithUnits?.[column.getColId()] ?? []).forEach((entry) => {
                    if (!seenSet.has(entry)) {
                        seenSet.add(entry);
                    }
                });
            }
        });
    }
};

/**
 * This function is counting horizontal cell count > 0 for grouped.
 * For individual door, this will take max value from children rows
 */
export const STORE_WITH_UNITS = (
    values: number[],
    _options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const colType = gridGetterParams.column.getColDef().type as ColumnTypes;
    if (colType === ColumnTypes.DoorBulkQuantity) {
        // For door column, we take max value from children rows. Eg: [1, 0, 0, 0] will yield 1
        return findMax(values);
    } else {
        const groupSet = new Set<string>();
        countUniqueDoor(groupSet, gridGetterParams.node, gridGetterParams.column);
        return groupSet.size || undefined;
    }
};
